enum AssignedPaymentMethodType {
    Existing = 'Existing',
    Card = 'Credit/Debit Card',
    Bank = 'Bank Account',
}

export default AssignedPaymentMethodType;
